var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8.62501 24.2101L27.7428 43.3279L23.5001 47.5705L0.139728 24.2101L23.5001 0.849739L27.7428 5.09238L8.62501 24.2101Z","fill":"white"}));
}

Arrow.defaultProps = {"viewBox":"0.13972799479961395 0.8497390151023865 27.603071212768555 46.720760345458984","fill":"none","preserveAspectRatio":"xMidYMid meet","role":"img"};

module.exports = Arrow;

Arrow.default = Arrow;
